// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation-root-ee7fbd44eb0324bf9af715e186761c25","ul":"Navigation-ul-3c4ae4d1c3d04533c4a6b59433839418"};